import { isFalsy } from '../../Helpers/helpers';

/**
 * Checks if the given string contains the given text snippet
 * @function doesStringInclude
 * @param {string} str
 * @param {string} key
 * @return {boolean}
 * @example doesStringInclude('The quick brown fox', 'Quick') => true
 * @example doesStringInclude('The quick brown fox', 'fax') => false
 */
const doesStringInclude = (str, text) => {
  if (isFalsy(str)) return false;

  const sliced = str.slice(0).toLowerCase();
  return sliced.includes(text.toLowerCase());
};

export default doesStringInclude;
